<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Gestion des ateliers">
        <v-row>
          <v-col cols="12" md="4">
            <router-link :to="{ name: 'form-atelier' }" tag="v-btn">
              <v-icon title="Ajouter un atelier">mdi-plus</v-icon>
              Ajouter un atelier</router-link
            >
          </v-col>
        </v-row>
        <v-row v-if="ateliers.length > 0">
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="ateliers"
              hide-default-footer
              disable-pagination
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              item-key="id"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-row>
                  <v-select
                    v-if="listeCampus.length > 2"
                    v-model="filtreCampus"
                    label="Filtre campus"
                    :items="listeCampus"
                    item-value="id"
                    item-text="libelle"
                    class="mx-5"
                  >
                  </v-select>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Recherche"
                    single-line
                    hide-details
                    class="mx-5"
                  ></v-text-field>
                </v-row>
              </template>
              <template v-slot:[`item.campus`]="{ item }">
                {{ item.campus.libelle }}
              </template>
              <template v-slot:[`item.dateDebut`]="{ item }">
                {{ formatDateDebut(item.dateDebut) }}
              </template>
              <template v-slot:[`item.ouvert`]="{ item }">
                <span v-if="isAtelierEchu(item)">Échu</span>
                <span v-else-if="!item.ouvert">Fermé</span>
                <span v-else-if="item.nbInscrits >= item.nbPlaces">Plein</span>
                <span v-else>Ouvert</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <router-link
                  :to="{
                    name: 'form-atelier',
                    params: {
                      idAtelier: item.id,
                    },
                  }"
                >
                  <v-icon
                    v-if="isAtelierEchu(item)"
                    class="mr-2"
                    title="Voir l'atelier"
                    color="primary"
                    >mdi-eye</v-icon
                  >
                  <v-icon
                    v-else
                    class="mr-2"
                    title="Éditer l'atelier"
                    color="primary"
                    >mdi-pencil</v-icon
                  ></router-link
                >

                <ActionConfirmation
                  v-if="item.nbInscrits === 0"
                  icone="mdi-delete"
                  title="Supprimer l'atelier"
                  @ok="deleteAtelier(item.id)"
                ></ActionConfirmation>
                <router-link
                  :to="{
                    name: 'inscrits-atelier',
                    params: {
                      idAtelier: item.id,
                    },
                  }"
                >
                  <v-icon
                    v-if="item.nbInscrits > 0"
                    class="mr-2"
                    title="Liste des inscrits"
                    color="primary"
                    >mdi-format-list-bulleted</v-icon
                  ></router-link
                >
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import BaseBlock from "@/components/base/BaseBlock";
import ApiAtelierRepository from "@/repositories/ApiAtelierRepository";
import ActionConfirmation from "@/components/ActionConfirmation";

export default {
  name: "GestionAteliers",
  components: { BaseBlock, ActionConfirmation },
  props: ["idCampus"],

  data() {
    return {
      headers: [
        {
          text: "Animateur",
          align: "left",
          value: "nomAnimateur",
        },
        {
          text: "Campus",
          align: "left",
          value: "campus",
          sortable: false,
          filter: (value) => {
            if (!this.filtreCampus) return true;
            return value.id == parseInt(this.filtreCampus);
          },
        },
        {
          text: "Date et heure début",
          align: "left",
          value: "dateDebut",
        },
        {
          text: "Nombre de places",
          align: "left",
          value: "nbPlaces",
        },
        {
          text: "Nombre d'inscrits",
          align: "left",
          value: "nbInscrits",
        },
        {
          text: "État",
          align: "left",
          value: "ouvert",
          sortable: false,
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
        },
      ],
      filtreCampus: "",
      search: "",
      ateliers: [],
      loading: false,
      listeCampus: [],
      sortBy: "dateDebut",
      sortDesc: false,
    };
  },
  watch: {
    filtreCampus(id) {
      this.sortBy = "dateDebut";
      this.sortDesc = false;
      sessionStorage.gesAtelier_campus = id;
    },
  },
  async created() {
    if (sessionStorage.gesAtelier_campus) {
      if (sessionStorage.gesAtelier_campus != 0) {
        this.filtreCampus = parseInt(sessionStorage.gesAtelier_campus);
      }
    }
    await this.getAteliers();
  },
  computed: {},
  methods: {
    async getAteliers() {
      try {
        const ateliers =
          await ApiAtelierRepository.getAteliersByReferentSuaio();
        this.ateliers = ateliers;
        this.listeCampus = this.getListeCampus(ateliers);
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      }
    },
    async deleteAtelier(id, idCampus) {
      this.loading = true;
      try {
        await ApiAtelierRepository.deleteAtelier(id);
        await this.getAteliers(idCampus);
        if (this.listeCampus.length < 3) {
          this.filtreCampus = "";
        }
        this.$toast.success("Atelier supprimé");
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      } finally {
        this.loading = false;
      }
    },
    isAtelierEchu(atelier) {
      return moment() > moment(atelier.dateDebut) ? true : false;
    },
    formatDateDebut(dateDebut) {
      return moment(dateDebut).format("DD/MM/YYYY HH:mm");
    },
    getListeCampus(ateliers) {
      const campusAteliers = ateliers.map((atelier) => atelier.campus);
      const listeCampus = [];
      for (let campusAtelier of campusAteliers) {
        listeCampus.some((campus) => campus.id === campusAtelier.id)
          ? {}
          : listeCampus.push(campusAtelier);
      }
      listeCampus.push({ id: null, libelle: "" });
      listeCampus.sort((a, b) =>
        a.libelle.toLowerCase().localeCompare(b.libelle.toLowerCase())
      );
      return listeCampus;
    },
  },
};
</script>
